// src/pages/Vehicles.jsx
import React from "react";
import VehicleSection from "../homeComponents/home/VehicleSection";

const Vehicles = () => (
  <section className="pb-24 md:pb-16">
    <VehicleSection />
  </section>
);

export default Vehicles;